import { render } from "./App.vue?vue&type=template&id=07dc2f68"
const script = {}

import "./App.vue?vue&type=style&index=0&id=07dc2f68&lang=scss"
script.render = render

export default script